<template>
  <div class="error-component page-not-found animate__fadeIn">
    <div class="margin-auto center text-center flex">
      <div v-if="!logoSrc" class="logo center text-center">[Company logo]</div>
      <div v-else="" :style="logoStyle" class="logo center text-center"></div>
    </div>

    <h1 class="main-title block text-center margin-xl-top margin-m-bottom">
      {{ tt("core.404.title") }}
    </h1>
    <p class="margin-auto text-center text-l">{{ tu("core.404.explain") }}</p>
    <div class="flex-middle flex-center margin-2xl-top">
      <form-button class="width-expand" icon="home" @click="$router.push('/')">{{
        t("core.404.buttonCta")
      }}</form-button>
    </div>
  </div>
</template>

<script>
// todo: default texts, props etc

export default {
  props: {
    logoSrc: {
      type: [String, Boolean],
      default: "core/images/logos/main.png",
    },
  },
  data: function () {
    return {};
  },
  meta: "admin.404.metaTitle",
  computed: {
    logoStyle() {
      if (!this.logoSrc) {
        return [];
      }

      let url = utilities.requireAsset(this.logoSrc);
      return {
        backgroundImage: "url('" + url + "')",
        'max-height': "80px",
        width: 'auto',
      };
    },
  },
  watch: {},
  created() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.logo {
  flex: auto;
  height: 80px;
  width: auto;
  background-size: auto 100%;
  background-position: center;
  background-repeat: no-repeat;
  margin-bottom: var(--margin-xl);

  @media (max-width: 767px) {
    height: 60px;
    width: auto;
    background-size: auto 60%;
    margin-bottom: var(--margin-m);
  }
}

.main-title {
  margin-bottom: var(--margin-l);

  @media (max-width: 767px) {
    font-size: var(--font-2xl);
    margin-bottom: var(--margin-xl);
  }
}

.login-footer-links-inner {
  @media (max-width: 767px) {
    flex-wrap: wrap;
  }
}

.link-wrap {
  @media (max-width: 767px) {
    margin-bottom: var(--margin-m);
  }

  &:last-of-type {
    @media (max-width: 767px) {
      margin-bottom: 0;
    }
  }
}
.login-component {
  max-width: calc(90vw - 60px);
  width: 550px;
  flex: 550px;

  @media screen and (max-width: 640px) {
    max-width: calc(90vw - 60px);
    width: 80vw;
    flex: 80vw;
  }

  @media screen and (max-width: 400px) {
    max-width: calc(90vw - 20px);
    width: 90vw;
    flex: 90vw;
  }

  .uk-card-body {
    padding-top: 0;
    padding-bottom: 0;
    @media screen and (max-width: 400px) {
      padding: 20px 10px;
    }
  }

  .uk-logo {
    display: inline-block;
  }

  .login-footer-links {
    @media screen and (max-width: 640px) {
      flex-wrap: wrap;
    }

    .link-wrap {
      @media screen and (max-width: 640px) {
        flex: 100%;
      }
    }
  }
}
</style>
